<template>
    <div :id="'date-' + dayDate" :class="['meals-weekly', { 'active': isToday }]">
        <meals-week-list-date :date="dayDate" :evaluation="dayEvaluation"></meals-week-list-date>

        <div class="meals-list">
            <template v-if="hasMeals && meals">
                <meals-week-list-item
                    v-for="(meal, index) in mealsArray"
                    :meal="meal"
                    :coach="coachUser"
                    :key="index"
                    :editable="editable"
                ></meals-week-list-item>
            </template>
            <meals-week-list-empty v-else></meals-week-list-empty>
        </div>
    </div>
</template>
<script>
    import MealsWeekListDate from './MealsWeekListDate'
    import MealsWeekListItem from './MealsWeekListItem'
    import MealsWeekListEmpty from './MealsWeekListEmpty'

    export default {
        components: {
            MealsWeekListDate,
            MealsWeekListItem,
            MealsWeekListEmpty
        },
        props: {
            coachUser: {
                type: Object,
                required: false
            },
            mealsEvaluation: {
                type: Object,
                required: true
            },
            editable: {
                type: Boolean,
                default: false
            },
            weekStart: {
                type: String,
                required: true
            },
            meals: {
                required: true
            }
        },
        mounted() {
            //this.initSlider()
            if(this.isToday) {
                $(".tab-meal a").on('click', function() {
                    setTimeout(function(){
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('.meals-weekly.active').offset().top - 250
                        },300)
                    }, 100);
                });
            }
        },
        computed: {
            dayDate() {
                return moment(this.weekStart).add(this.$vnode.key - 1, 'days').format('YYYY-MM-DD').toString()
            },
            dayEvaluation() {
                return this.mealsEvaluation.days[this.dayDate]
            },
            isToday() {
                if (moment(this.dayDate).isSame(moment(), 'day')) {
                    return true
                } else {
                    return false
                }
            },
            hasMeals() {
                if (this.meals[this.dayDate]) {
                    return true
                } else {
                    return false
                }
            },
            mealsArray() {
                return _.sortBy(this.meals[this.dayDate], 'time')
            }
        },
        methods: {
            initSlider() {
                $('.meals-list').not('.slick-initialized').slick({
                    centerMode: false,
                    arrows: true,
                    variableWidth: true,
                    dots: false,
                    slidesToShow: 4,
                    initialSlide: 0,
                    infinite: false,
                    focusOnSelect: true,
                    nextArrow: '<button class="slick-next"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></button>',
                    prevArrow: '<button class="slick-prev"><svg aria-hidden="true" height="20px" width="10px" focusable="false" data-prefix="fas" data-icon="angle-left" class="svg-inline--fa fa-angle-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#fff" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg></svg></button>',
                    responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                        slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1370,
                        settings: {
                        slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                        slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                        slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: "unslick"
                    }
                    ]
                });
            }
        }
    }
</script>
